/* eslint-disable no-sequences */
import Transliterable from 'es6/models/transliterable';
import Sentence from 'es6/models/sentence';
import Goal from 'es6/models/goal';

export default class Item {
  constructor(attrs = {}) {
    this.id = attrs.id;
    this.cue = new Transliterable(attrs.cue);
    this.response = new Transliterable(attrs.response);
    this.goalItems = (attrs.goalItems || []).map(goalItem => new GoalItem(goalItem));
  }

  getText() {
    return this.cue.getText();
  }

  getTranscription() {
    return this.cue.transcription;
  }

  getTransliteration() {
    return this.cue.getTransliteration();
  }

  getTranslation() {
    return this.response.getText();
  }

  getPartOfSpeech() {
    return this.cue.partOfSpeech;
  }

  getSound() {
    return (this.goalItems[0] || {}).sound;
  }
}

export class GoalItem {
  constructor(goalItem) {
    this.id =  (goalItem.goal || {}).id;
    this.goal = new Goal(goalItem.goal),
    this.sound = goalItem.sound;
    this.sentences =  (goalItem.sentences || []).map(sentence => new Sentence(sentence));
  }
}
